import { connect } from 'react-redux';
import PAPBase from 'pap/components/common/pap_base';

const mapStateToProps = ({ user }) => {
  return {
    user
  };
}

export default connect(mapStateToProps)(PAPBase);



// WEBPACK FOOTER //
// ./pap/containers/common/pap_base.js